<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            v-if="scope.row.status == 'NOT_PAID'"
            @click.stop="toPay(scope.row,scope.index)"
          >去结算</el-button>
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.status == 'NOT_PAID'"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >客户退货</el-button>
        </template>
      </avue-crud>

      <el-dialog
        title="手动结算"
        :visible.sync="dialogVisible"
        width="50%"
      >
        <el-form
          :model="form"
          style="margin-left:50px"
        >

          <el-form-item
            label="推广员昵称："
            :label-width="formLabelWidth"
            style="width:600px"
          >
            <span>{{form.name}}</span>
          </el-form-item>
          <el-form-item
            label="推广员账户："
            :label-width="formLabelWidth"
            style="width:600px"
          >
            <span>{{form.account}}</span>
          </el-form-item>
          <el-form-item
            label="佣金预计："
            :label-width="formLabelWidth"
            style="width:600px"
          >
            <span>{{form.payMoney}} 元</span>
          </el-form-item>
          <el-form-item
            label="实付金额："
            :label-width="formLabelWidth"
            style="width:600px"
          >
            <el-input
              v-model="form.money"
              style="width:100px"
              onkeyup="value=value.replace(/[^\d^\.]+/g,'').replace('.','$#$').replace(/\./g,'').replace('$#$','.')"
            ></el-input> 元
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            @click="toPayMoney"
          >去 支 付</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog
        :visible.sync="payMoneyDialog"
        title="选择支付方式"
        center
        width="550px"
      >
        <div style="font-size: 14px">
          <div style="display: flex;justify-content:center;margin-top:40px">
            <el-radio
              v-model="radio"
              label="BALANCE"
              v-if="isEnough==='false'"
            >
              账户余额(
              <span style="color:red;font-size:12px;">余额不足</span>
              <a
                href="#"
                style="color:#409EFF;text-decoration: underline;margin-left:8px"
                @click="toPayBalance"
              >去充值</a> )
            </el-radio>
            <el-radio
              v-model="radio"
              label="BALANCE"
              v-if="isEnough==='true'"
            >账户余额({{balance}}元)</el-radio>
            <el-radio
              v-model="radio"
              label="WX_PAY"
            >微信支付(需付1%的手续费)</el-radio>
          </div>
        </div>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="immediatePayment"
          >&nbsp;&nbsp;&nbsp;立即支付&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="danger"
            size="mini"
            @click="payMoneyDialog = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
      <template>
        <el-dialog
          title="二维码支付"
          :visible.sync="QRCodeDialog"
          align="center"
        >
          <vue-qr
            :text="config.value"
            :size="200"
          ></vue-qr>
          <el-button @click="QRCodeDialog = false">关闭</el-button>
        </el-dialog>
      </template>
    </basic-container>
  </div>
</template>

<script>
import { settlementOption } from "@/const/salesCloud/settlementOption";
import {
  findClearingList,
  returnPlace,
  payPlace,
  addSystemClassify,
  editSystemClassify,
  delSystemClassify
} from "@/api/salesCloud/settlement";
import VueQr from "vue-qr";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import {
  balancePay,
  getBalance,
  immediatePay
} from "@/api/salesCloud/mobileRedPacket";
export default {
  name: "settlement",
  data() {
    return {
      tableOption: settlementOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogVisible: false,
      payMoneyDialog: false,
      QRCodeDialog: false,
      classifySelects: [],
      config: {},
      balance: 0.0,
      isEnough: "true",
      radio: "BALANCE",
      currClassify: "",
      form: { name: "0" },
      formLabelWidth: "120px",
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  components: {
    VueQr
  },
  mounted() {},
  computed: {},
  props: [],
  methods: {
    toPayBalance() {
      this.$router.push({ path: "/salesCloud/accountBalance" });
    },

    toPayMoney() {
      console.log(this.form);
      let reg = /(^[1-9][0-9]{0,8}([.][0-9]{0,2})?$)|(^0?(\.[0-9]{0,2})?$)/;
      if (!reg.test(this.form.money)) {
        this.$message({
          showClose: true,
          message: "请输入正确的金额",
          type: "error"
        });
        return;
      }
      getBalance().then(res => {
        let data = JSON.parse(res.data);
        this.balance = data.rows[0].balance;
        if (this.balance < this.form.money) {
          this.isEnough = "false";
        } else {
          this.isEnough = "true";
        }
      });
      this.dialogVisible = false;
      this.payMoneyDialog = true;
    },
    toPay(row) {
      this.clean();
      this.form = row;
      this.rowId = row.id;
      this.dialogVisible = true;
      console.log(this.form);
    },
    clean() {
      this.form.money = "";
      this.currClassify = "";
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findClearingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findClearingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      // if (
      //   null != params.startDate_endDate &&
      //   undefined != params.startDate_endDate &&
      //   "" != params.startDate_endDate
      // ) {
      //   params.createTimeStart = params.startDate_endDate[0];
      //   params.createTimeEnd = params.startDate_endDate[1];
      // } else {
      //   delete params.createTimeStart;
      //   delete params.createTimeEnd;
      // }
      findClearingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      findClearingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findClearingList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.rootId = this.currClassify;
      console.log(row);
      addSystemClassify(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      this.$confirm(`是否确认客户退货?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = { id: row.id };
          returnPlace(params).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "客户退货成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      let params = {};
      params.id = row.id;
      if (row.name) {
        params.name = row.name.replace(/(^\s*)|(\s*$)/g, "");
        params.rootId = row.rootId;
      }
      if (!row.name.replace(/(^\s*)|(\s*$)/g, "")) {
        this.$message({
          showClose: true,
          message: "工程进度名称不能为空",
          type: "error"
        });
        done();
        return;
      }
      editSystemClassify(params).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    immediatePayment() {
      if (this.radio == "BALANCE") {
        let params = {
          id: this.rowId,
          payType: this.radio,
          money: this.form.money
        };
        payPlace(params).then(res => {
          if (res.code == "200") {
            this.$message({
              showClose: true,
              message: "支付成功",
              type: "success"
            });
            this.payMoneyDialog = false;
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error"
            });
          }
        });
      } else {
        let params = {
          id: this.rowId,
          payType: this.radio,
          money: this.form.money
        };
        payPlace(params).then(response => {
          this.tableLoading = false;
          if (response.code == "200") {
            let data = response.data;
            console.log(data);
            let count = 0;
            wxNativePayQuery(data.outTradeNo).then(res => {
              console.log(res);
              if (res.code == "200") {
                if (res.data == "SUCCESS") {
                  let _this = this;
                  setTimeout(function() {
                    _this.QRCodeDialog = false;
                    _this.$message({
                      showClose: true,
                      message: "支付成功",
                      type: "success"
                    });
                    _this.payMoneyDialog = false;
                    _this.handleList();
                    done();
                  }, 1000);
                } else {
                  count++;
                  if (count < 3) {
                    wxNativePayQuery(data.outTradeNo).then(res => {
                      if (res.code == "200") {
                        if (res.data == "SUCCESS") {
                          let _this = this;
                          setTimeout(function() {
                            _this.QRCodeDialog = false;
                            _this.$message({
                              showClose: true,
                              message: "支付成功",
                              type: "success"
                            });
                            _this.handleList();
                            _this.payMoneyDialog = false;
                            _this.rechargeDialog = false;
                            _this.payMoneyDialog = false;

                            done();
                            console.log("进来了");
                          }, 1000);
                        } else {
                          this.QRCodeDialog = false;
                          this.$message({
                            showClose: true,
                            message: "支付超时",
                            type: "error"
                          });
                          done();
                          console.log("超时", new Date());
                        }
                      } else {
                        this.QRCodeDialog = false;
                        this.$message({
                          showClose: true,
                          message: "支付超时",
                          type: "error"
                        });
                        done();
                        console.log("超时", new Date());
                      }
                    });
                  }
                }
                //this.handleList();
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
                done();
                this.handleList();
              }
            });
            let start = new Date().getTime();
            while (true) if (new Date().getTime() - start > 1) break;
            this.config.value = "";
            this.config.value = data.codeUrl;
            console.log("集合：" + this.config.value);
            this.QRCodeDialog = true;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
            //???下面的感觉没用
            // done();
            // this.$refs.crud.rowAdd();
            return;
          }
          // let data = JSON.parse(res.data);
        });
      }
    }
  }
};
</script>

<style lang="scss">
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 150px;
}
.redPacket {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  margin-left: 10%;
  .content {
    display: flex;
  }
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
